import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { Plus, X, Dumbbell, Target, Clock, User, UsersRound, Pencil, Trash2, CheckCircle2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const EditPTModal = ({ onClose, onEdit, pt, members, trainers }) => {
  const [formData, setFormData] = useState(pt);
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
      <div className="bg-card_bg border border-border_soft p-8 rounded-2xl w-full max-w-md relative shadow-2xl">
        <button onClick={onClose} className="absolute top-6 right-6 text-text_secondary hover:text-text_primary transition-colors"><X size={20}/></button>
        <h2 className="text-2xl font-serif text-text_primary mb-6">Edit PT Schedule</h2>
        <form onSubmit={(e) => { e.preventDefault(); onEdit(formData, 'pt_assignments'); }} className="space-y-5">
          <div>
            <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Select Member</label>
            <select required value={formData.client} onChange={e=>setFormData({...formData, client: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary appearance-none focus:ring-1 focus:ring-primary/50">
              {members.map(m => <option key={m.id} value={m.name}>{m.name}</option>)}
            </select>
          </div>
          <div>
            <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Trainer</label>
            <select required value={formData.trainer} onChange={e=>setFormData({...formData, trainer: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary appearance-none focus:ring-1 focus:ring-primary/50">
              {trainers.map(t => <option key={t.id} value={t.name}>{t.name} ({t.role})</option>)}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-5">
            <div>
              <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Time</label>
              <input required type="time" value={formData.time} onChange={e=>setFormData({...formData, time: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary focus:ring-1 focus:ring-primary/50" />
            </div>
            <div className="flex items-center h-full pt-6">
              <label className="flex items-center gap-3 text-sm font-medium text-text_primary cursor-pointer select-none">
                <div className={`w-6 h-6 rounded flex items-center justify-center border transition-colors ${formData.is_transformation ? 'bg-primary border-primary' : 'bg-card_bg border-border_soft'}`}>
                  {formData.is_transformation && <CheckCircle2 size={14} className="text-[#111827]"/>}
                </div>
                <input type="checkbox" className="hidden" checked={formData.is_transformation} onChange={e=>setFormData({...formData, is_transformation: e.target.checked})} />
                Transformation Plan
              </label>
            </div>
          </div>
          <div>
            <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Focus Area</label>
            <input required type="text" value={formData.focus} onChange={e=>setFormData({...formData, focus: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary focus:ring-1 focus:ring-primary/50" />
          </div>
          <button type="submit" className="w-full bg-primary text-[#111827] font-bold py-4 rounded-xl mt-8 hover:bg-primary_hover transition-colors shadow-md">Save</button>
        </form>
      </div>
    </div>
  );
};

const EditClassModal = ({ onClose, onEdit, cls, trainers }) => {
  const [formData, setFormData] = useState(cls);
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
      <div className="bg-card_bg border border-border_soft p-8 rounded-2xl w-full max-w-md relative shadow-2xl">
        <button onClick={onClose} className="absolute top-6 right-6 text-text_secondary hover:text-text_primary transition-colors"><X size={20}/></button>
        <h2 className="text-2xl font-serif text-text_primary mb-6">Edit Class</h2>
        <form onSubmit={(e) => { e.preventDefault(); onEdit(formData, 'classes'); }} className="space-y-5">
          <div>
            <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Class Name</label>
            <input required type="text" value={formData.name} onChange={e=>setFormData({...formData, name: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary focus:ring-1 focus:ring-primary/50" />
          </div>
          <div>
            <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Trainer</label>
            <select required value={formData.instructor} onChange={e=>setFormData({...formData, instructor: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary appearance-none focus:ring-1 focus:ring-primary/50">
              {trainers.map(t => <option key={t.id} value={t.name}>{t.name} ({t.role})</option>)}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-5">
            <div>
              <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Time</label>
              <input required type="time" value={formData.time} onChange={e=>setFormData({...formData, time: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary focus:ring-1 focus:ring-primary/50" />
            </div>
            <div>
              <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Area</label>
              <input required type="text" value={formData.spot} onChange={e=>setFormData({...formData, spot: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary focus:ring-1 focus:ring-primary/50" />
            </div>
          </div>
          <button type="submit" className="w-full bg-primary text-[#111827] font-bold py-4 rounded-xl mt-8 hover:bg-primary_hover transition-colors shadow-md">Save</button>
        </form>
      </div>
    </div>
  );
};

export default function Trainers() {
  const [activeTab, setActiveTab] = useState("pt");
  const [assignments, setAssignments] = useState([]);
  const [classes, setClasses] = useState([]);
  const [members, setMembers] = useState([]);
  const [trainers, setTrainers] = useState([]);

  const [showPTModal, setShowPTModal] = useState(false);
  const [showClassModal, setShowClassModal] = useState(false);
  const [showEditPT, setShowEditPT] = useState(null);
  const [showEditClass, setShowEditClass] = useState(null);

  const [ptData, setPTData] = useState({ client: "", trainer: "", time: "08:00 AM", is_transformation: false, focus: "" });
  const [classData, setClassData] = useState({ name: "", instructor: "", time: "06:00 PM", spot: "Main Studio" });

  const fetchData = useCallback(async () => {
    try {
      if(activeTab === 'pt') {
        const resPT = await axios.get(`${BACKEND_URL}/api/pt_assignments`);
        setAssignments(resPT.data);
      } else {
        const resCls = await axios.get(`${BACKEND_URL}/api/classes`);
        setClasses(resCls.data);
      }
      const resMem = await axios.get(`${BACKEND_URL}/api/members`);
      setMembers(resMem.data);
      const resHR = await axios.get(`${BACKEND_URL}/api/hr`);
      setTrainers(resHR.data.filter(emp => (emp.role||"").toLowerCase().includes("trainer") || (emp.role||"").toLowerCase().includes("coach") || (emp.role||"").toLowerCase().includes("instructor")));
    } catch(e) { console.error(e); }
  }, [activeTab]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleAssignPT = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BACKEND_URL}/api/pt_assignments`, ptData);
      setShowPTModal(false);
      setPTData({ client: "", trainer: "", time: "08:00 AM", is_transformation: false, focus: "" });
      fetchData();
    } catch(e) { console.error(e); }
  };

  const handleCreateClass = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BACKEND_URL}/api/classes`, classData);
      setShowClassModal(false);
      setClassData({ name: "", instructor: "", time: "06:00 PM", spot: "Main Studio" });
      fetchData();
    } catch(e) { console.error(e); }
  };

  const handleEdit = async (data, collection) => {
    try {
      await axios.put(`${BACKEND_URL}/api/admin/update/${collection}/${data.id}`, data);
      setShowEditPT(null);
      setShowEditClass(null);
      fetchData();
    } catch(e) { alert(e.response?.data?.detail || "Admin access required"); }
  };

  const handleDelete = async (id, collection) => {
    if(window.confirm("Remove this record permanently?")) {
      try {
        await axios.delete(`${BACKEND_URL}/api/admin/delete/${collection}/${id}`);
        fetchData();
      } catch(e) { alert(e.response?.data?.detail || "Admin access required"); }
    }
  };

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-8 duration-700 relative">
      <div className="flex flex-col md:flex-row justify-between md:items-end gap-6 mb-4">
        <div>
          <h1 className="text-4xl font-serif text-text_primary mb-3">PT & Classes</h1>
          <p className="text-text_secondary text-sm">Manage group class timetables and 1-on-1 personal training.</p>
        </div>
        <div className="flex gap-3">
          {activeTab === 'pt' ? (
             <button onClick={() => setShowPTModal(true)} className="bg-primary text-[#111827] px-6 py-3.5 rounded-xl font-bold hover:bg-primary_hover transition-colors flex items-center gap-2 shadow-md">
               <Plus size={20} /> Assign PT
             </button>
          ) : (
             <button onClick={() => setShowClassModal(true)} className="bg-primary text-[#111827] px-6 py-3.5 rounded-xl font-bold hover:bg-primary_hover transition-colors flex items-center gap-2 shadow-md">
               <Plus size={20} /> Add Class
             </button>
          )}
        </div>
      </div>

      <div className="flex gap-4 border-b border-border_soft/30 pb-3">
        <button onClick={() => setActiveTab('pt')} className={`flex items-center gap-2.5 px-5 py-2.5 font-bold rounded-xl transition-all ${activeTab === 'pt' ? 'bg-primary/15 text-gold shadow-glow border border-primary/30' : 'text-text_secondary hover:text-text_primary hover:bg-card_bg'}`}>
          <Dumbbell size={18} strokeWidth={2.5} /> Personal Training
        </button>
        <button onClick={() => setActiveTab('classes')} className={`flex items-center gap-2.5 px-5 py-2.5 font-bold rounded-xl transition-all ${activeTab === 'classes' ? 'bg-primary/15 text-gold shadow-glow border border-primary/30' : 'text-text_secondary hover:text-text_primary hover:bg-card_bg'}`}>
          <UsersRound size={18} strokeWidth={2.5} /> Classes
        </button>
      </div>

      {activeTab === 'pt' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {assignments.length === 0 && <p className="text-text_secondary col-span-full">No PT clients yet.</p>}
          {assignments.map(sch => (
            <div key={sch.id} className="bg-card_bg border border-border_soft p-8 rounded-2xl shadow-sm relative overflow-hidden group transition-all hover:border-primary/40 hover:-translate-y-1">
              <div className="absolute top-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity z-10 bg-card_bg p-1.5 rounded-lg border border-border_soft/50">
                <button onClick={() => setShowEditPT(sch)} className="p-1.5 text-text_secondary hover:text-gold transition-colors" title="Edit"><Pencil size={16}/></button>
                <button onClick={() => handleDelete(sch.id, 'pt_assignments')} className="p-1.5 text-text_secondary hover:text-accent_danger transition-colors" title="Delete"><Trash2 size={16}/></button>
              </div>
              {sch.is_transformation && (
                <div className="absolute top-0 right-0 bg-primary/20 text-gold text-[9px] font-bold px-4 py-1.5 uppercase tracking-widest rounded-bl-xl flex items-center gap-1.5 border-b border-l border-primary/30">
                  <Target size={12}/> Transformation Plan
                </div>
              )}
              <div className="flex items-center gap-5 mb-8 mt-2">
                <div className="w-14 h-14 bg-main_bg rounded-2xl flex items-center justify-center text-gold border border-border_soft/50 shadow-inner">
                  <Dumbbell size={28} strokeWidth={1.5} />
                </div>
                <div>
                  <h3 className="text-text_primary font-bold text-xl tracking-tight mb-1">{sch.trainer}</h3>
                  <p className="text-gold text-xs font-semibold uppercase tracking-widest">{sch.focus}</p>
                </div>
              </div>
              <div className="space-y-4 border-t border-border_soft/30 pt-6">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-text_secondary flex items-center gap-2"><User size={16} className="text-gold opacity-80" /> Member</span>
                  <span className="text-text_primary font-bold tracking-wide">{sch.client}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-text_secondary flex items-center gap-2"><Clock size={16} className="text-gold opacity-80" /> Time</span>
                  <span className="text-text_primary font-mono bg-card_bg px-3 py-1 rounded-lg border border-border_soft/30">{sch.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {activeTab === 'classes' && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {classes.length === 0 && <p className="text-text_secondary col-span-full">No classes yet.</p>}
          {classes.map(cls => (
            <div key={cls.id} className="bg-card_bg border border-border_soft p-8 rounded-2xl shadow-sm relative group transition-all hover:border-primary/40 hover:-translate-y-1">
              <div className="absolute top-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity z-10">
                <button onClick={() => setShowEditClass(cls)} className="p-2 bg-card_bg border border-border_soft/50 rounded-lg text-text_secondary hover:text-gold transition-colors"><Pencil size={16}/></button>
                <button onClick={() => handleDelete(cls.id, 'classes')} className="p-2 bg-card_bg border border-border_soft/50 rounded-lg text-text_secondary hover:text-accent_danger transition-colors"><Trash2 size={16}/></button>
              </div>
              <div className="flex flex-col items-start mb-6 pr-16">
                <span className="px-3 py-1 bg-primary/10 text-gold border border-primary/20 text-[10px] font-bold rounded-full uppercase tracking-widest mb-3">{cls.spot}</span>
                <h3 className="text-2xl font-bold text-text_primary tracking-tight">{cls.name}</h3>
              </div>
              <div className="space-y-4 border-t border-border_soft/30 pt-6">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-text_secondary flex items-center gap-2"><User size={16} className="text-gold opacity-80" /> Trainer</span>
                  <span className="text-text_primary font-bold">{cls.instructor}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-text_secondary flex items-center gap-2"><Clock size={16} className="text-gold opacity-80" /> Time</span>
                  <span className="text-text_primary font-mono bg-card_bg px-3 py-1 rounded-lg border border-border_soft/30">{cls.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showEditPT && <EditPTModal pt={showEditPT} members={members} trainers={trainers} onClose={() => setShowEditPT(null)} onEdit={handleEdit} />}
      {showEditClass && <EditClassModal cls={showEditClass} trainers={trainers} onClose={() => setShowEditClass(null)} onEdit={handleEdit} />}

      {/* Adding Modals (Same style updates applied logically...) */}
      {showPTModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
          <div className="bg-card_bg border border-border_soft p-8 rounded-2xl w-full max-w-md relative shadow-2xl">
            <button onClick={() => setShowPTModal(false)} className="absolute top-6 right-6 text-text_secondary hover:text-text_primary transition-colors"><X size={20}/></button>
            <h2 className="text-2xl font-serif text-text_primary mb-6">Assign PT</h2>
            <form onSubmit={handleAssignPT} className="space-y-5">
              <div>
                <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Member</label>
                <select required value={ptData.client} onChange={e=>setPTData({...ptData, client: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary appearance-none focus:ring-1 focus:ring-primary/50">
                  <option value="">-- Select Member --</option>
                  {members.map(m => <option key={m.id} value={m.name}>{m.name}</option>)}
                </select>
              </div>
              <div>
                <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Trainer</label>
                <select required value={ptData.trainer} onChange={e=>setPTData({...ptData, trainer: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary appearance-none focus:ring-1 focus:ring-primary/50">
                  <option value="">-- Select Trainer --</option>
                  {trainers.map(t => <option key={t.id} value={t.name}>{t.name} ({t.role})</option>)}
                </select>
              </div>
              <div className="grid grid-cols-2 gap-5">
                <div>
                  <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Time</label>
                  <input required type="time" value={ptData.time} onChange={e=>setPTData({...ptData, time: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary focus:ring-1 focus:ring-primary/50" />
                </div>
                <div className="flex items-center h-full pt-6">
                  <label className="flex items-center gap-3 text-sm font-medium text-text_primary cursor-pointer select-none">
                    <input type="checkbox" checked={ptData.is_transformation} onChange={e=>setPTData({...ptData, is_transformation: e.target.checked})} className="accent-primary w-5 h-5 rounded" />
                    Transformation
                  </label>
                </div>
              </div>
              <div>
                <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Focus Area</label>
                <input required type="text" placeholder="Hypertrophy, Cut, etc." value={ptData.focus} onChange={e=>setPTData({...ptData, focus: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary focus:ring-1 focus:ring-primary/50" />
              </div>
              <button type="submit" className="w-full bg-primary text-[#111827] font-bold py-4 rounded-xl mt-8 hover:bg-primary_hover transition-colors shadow-md">Save</button>
            </form>
          </div>
        </div>
      )}

      {showClassModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-200">
          <div className="bg-card_bg border border-border_soft p-8 rounded-2xl w-full max-w-md relative shadow-2xl">
            <button onClick={() => setShowClassModal(false)} className="absolute top-6 right-6 text-text_secondary hover:text-text_primary transition-colors"><X size={20}/></button>
            <h2 className="text-2xl font-serif text-text_primary mb-6">Add Class</h2>
            <form onSubmit={handleCreateClass} className="space-y-5">
              <div>
                <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Class Name</label>
                <input required type="text" value={classData.name} onChange={e=>setClassData({...classData, name: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary focus:ring-1 focus:ring-primary/50" />
              </div>
              <div>
                <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Trainer</label>
                <select required value={classData.instructor} onChange={e=>setClassData({...classData, instructor: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary appearance-none focus:ring-1 focus:ring-primary/50">
                  <option value="">-- Select Trainer --</option>
                  {trainers.map(t => <option key={t.id} value={t.name}>{t.name} ({t.role})</option>)}
                </select>
              </div>
              <div className="grid grid-cols-2 gap-5">
                <div>
                  <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Time</label>
                  <input required type="time" value={classData.time} onChange={e=>setClassData({...classData, time: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary focus:ring-1 focus:ring-primary/50" />
                </div>
                <div>
                  <label className="text-xs font-semibold text-text_secondary mb-1.5 block uppercase tracking-wider">Area</label>
                  <input required type="text" placeholder="Zone A" value={classData.spot} onChange={e=>setClassData({...classData, spot: e.target.value})} className="w-full bg-card_bg border border-border_soft rounded-xl p-3.5 text-text_primary focus:ring-1 focus:ring-primary/50" />
                </div>
              </div>
              <button type="submit" className="w-full bg-primary text-[#111827] font-bold py-4 rounded-xl mt-8 hover:bg-primary_hover transition-colors shadow-md">Save</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
